import ReportSalesOrderItem from "../../../../components/@reports/sales/ReportSalesOrderItem";

import { ReportContextProvider } from "../../../../context/ReportContext";

import { reportScopes, reportTypes } from "../../../../hooks/api/useReports";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

import { validationSchema, initialValues, advancedValidationSchema, advancedInitialValues } from "../../../../schema/reports/sales/salesOrderItemSchema"

export default function SalesOrderItemReport() {

    let routeType = routeTypes.admin

    return (
        <ReportContextProvider
            routeType={routeType}
            reportScope={reportScopes.sales}
            reportType={reportTypes.sales.salesOrderItem.id}
            validationSchema={validationSchema}
            advancedValidationSchema={advancedValidationSchema}
            initialValues={initialValues}
            advancedInitialValues={advancedInitialValues}
        >
            <ReportSalesOrderItem
                routeType={routeType}
            />
        </ReportContextProvider>
    )
}       